/**
 * Term — a specialist word (CUF, PR, Specific Yield, Technical Availability …)
 * with its plain-language meaning from the server glossary on hover.
 *
 * UX-REV-001 U3: the standing requirement is that a layman can read every screen;
 * an unexplained abbreviation breaks that. <Term tkey="cuf">CUF</Term> underlines
 * the word and carries the glossary's plain meaning as a tooltip. It falls back to
 * rendering the children plainly when the glossary has no entry or has not loaded,
 * so it is always safe to wrap a label. React Query dedupes the single /v1/glossary
 * fetch across every Term on the page.
 */
import { useGetV1Glossary } from "@solarkey/api-client";
import type { ReactNode } from "react";

export function Term(props: { tkey: string; children: ReactNode }): ReactNode {
  const q = useGetV1Glossary();
  const entries =
    q.data?.status === 200
      ? ((q.data.data.data.entries ?? []) as { key?: string; term?: string; plain?: string }[])
      : [];
  const entry = entries.find((e) => e.key === props.tkey);
  if (!entry?.plain) return <>{props.children}</>;
  return (
    <abbr className="sk-term" title={`${entry.term ?? ""}: ${entry.plain}`.trim()}>
      {props.children}
    </abbr>
  );
}
